import { SeoPage, CtaInline } from './SeoLayout';
import { Link } from 'react-router-dom';
import { BUSINESS, getLocalBusinessSchema, getBreadcrumbSchema } from '../../data/businessInfo';
import { Paintbrush, Layers, Home, DoorOpen, Ruler, Square, ArrowRight, CheckCircle2 } from 'lucide-react';

// Liste der tatsächlich angebotenen Leistungen (aus bestehenden statischen SEO-Seiten abgeleitet)
export const SERVICES = [
  {
    slug: 'malerarbeiten',
    icon: Paintbrush,
    title: 'Malerarbeiten',
    metaTitle: 'Malerarbeiten Dormagen und Umgebung',
    short: 'Wand- und Deckenanstriche, Innenanstriche, Farbwahl-Beratung',
    intro: 'Klassische Maler­arbeiten für Wohnungen, Häuser, Büros und Praxen. Wir arbeiten mit hoch­wertigen, wisch­festen Farben und decken sorgfältig ab, damit Ihre Möbel und Böden nicht in Mitleiden­schaft gezogen werden.',
    bullets: [
      'Wand- und Deckenanstrich mit ein oder zwei Anstrichen',
      'Innenanstriche für Wohn-, Schlaf- und Kinderzimmer',
      'Farbberatung nach RAL, NCS oder Wunschmuster',
      'Streichen von Türen, Zargen, Heizkörpern und Fensterrahmen',
      'Isolier- und Sperrgrundierung bei Nikotin- oder Wasserflecken',
    ],
    goodFor: 'Renovierung vor Einzug, Zwischen-Renovierung bewohnter Räume, Wohnungs­auffrischung, Auszugs­renovierung.'
  },
  {
    slug: 'tapezierarbeiten',
    icon: Layers,
    title: 'Tapezierarbeiten',
    metaTitle: 'Tapezieren in Dormagen',
    short: 'Vliestapete, Raufaser, Struktur- und Fototapete',
    intro: 'Vom klassischen Raufaser­anstrich bis zur modernen Vlies- oder Foto­tapete. Wir übernehmen das komplette Tapezieren inklusive Unter­grund­vorbereitung, sauber und ohne Blasen an den Nähten.',
    bullets: [
      'Vliestapete verlegen (fugenlos, geradlinig)',
      'Raufaser mit anschließendem Anstrich',
      'Struktur- und Design­tapeten',
      'Foto­tapeten und Wand­bilder',
      'Alte Tapete fach­gerecht entfernen und Unter­grund vorbereiten',
    ],
    goodFor: 'Räume, in denen der Unter­grund Wellen oder feine Risse hat, oder wo eine bestimmte Optik gewünscht ist.'
  },
  {
    slug: 'renovierung',
    icon: Home,
    title: 'Renovierung',
    metaTitle: 'Renovierung Dormagen und Umgebung',
    short: 'Komplett­renovierung von Wohnungen und Häusern',
    intro: 'Kompletter Renovierungs­service, wenn Sie mehr wollen als nur einen frischen Anstrich. Wir koordinieren die einzelnen Gewerke — Anstrich, Tapete, Trockenbau, Boden — so, dass Ihre Wohnung in möglichst wenigen Tagen bezugsfertig ist.',
    bullets: [
      'Komplett­renovierungen zwischen Auszug und Einzug',
      'Renovierung einzelner Räume (Bad, Küche, Wohnzimmer)',
      'Kleinere Reparatur- und Ausbesserungs­arbeiten',
      'Materialbeschaffung und Entsorgung inklusive',
      'Koordination mit anderen Handwerkern auf Wunsch',
    ],
    goodFor: 'Vermieter zwischen zwei Mietverhältnissen, Käufer vor dem Einzug, Modernisierung älterer Wohnungen.'
  },
  {
    slug: 'wohnungsuebergabe',
    icon: DoorOpen,
    title: 'Wohnungsübergabe',
    metaTitle: 'Wohnungsübergabe Dormagen',
    short: 'Übergabe-Renovierung in 1–2 Tagen',
    intro: 'Der Klassiker vor Auszug oder Neu-Vermietung. Wir bringen die Wohnung schnell und günstig auf Übergabe-Standard, damit Sie Ihre Kaution ohne Diskussion zurück­bekommen — oder als Vermieter die nächste Miete pünktlich vereinnahmen können.',
    bullets: [
      'Wände weiß streichen (ein oder zwei Anstriche)',
      'Bohrlöcher fach­gerecht verspachteln',
      'Kleine Beschädigungen ausbessern',
      'Türen und Rahmen anfrischen bei Bedarf',
      'Auf Wunsch komplette Endreinigung koordinieren',
    ],
    goodFor: 'Mieter kurz vor dem Auszug, Vermieter zwischen Mietverhältnissen, Wohnungs­käufer vor dem Weiter­verkauf.'
  },
  {
    slug: 'trockenbau',
    icon: Ruler,
    title: 'Trockenbau',
    metaTitle: 'Trockenbau in Dormagen',
    short: 'Ständerwände, abgehängte Decken, Nischen',
    intro: 'Wände, Decken und Räume nach­träglich verändern — ohne monate­lange Baustelle. Trocken­bau ist die schnelle Lösung für neue Räume, versteckte Kabel oder eine gerade Decke.',
    bullets: [
      'Ständerwände und Raum­teiler (Metall- oder Holz­unterkonstruktion)',
      'Abgehängte Decken mit Beleuchtungs­aussparungen',
      'Vorsatz­schalen zur Wärme- oder Schall­dämmung',
      'Nischen, Regale und Einbau­schränke',
      'Verspachteln und Streichen der neuen Flächen',
    ],
    goodFor: 'Grund­riss­änderungen, nach­trägliche Dämmung, moderne Raum­gestaltung, Home­office aus einem großen Raum machen.'
  },
  {
    slug: 'bodenverlegung',
    icon: Square,
    title: 'Bodenverlegung',
    metaTitle: 'Bodenverlegung Dormagen',
    short: 'Laminat, Vinyl, Design­boden',
    intro: 'Neuer Boden als Teil einer Renovierung — oder als eigen­ständiger Auftrag. Wir arbeiten mit Laminat, Vinyl und Design­böden, inklusive Sockelleisten und dem Übergang zu angrenzenden Räumen.',
    bullets: [
      'Laminat­verlegung mit Klick- oder Klebe­system',
      'Vinyl- und Design­boden (LVT)',
      'Trittschall­dämmung und Ausgleichs­masse',
      'Sockelleisten sauber verlegen und anpassen',
      'Alten Boden auf Wunsch entfernen und entsorgen',
    ],
    goodFor: 'Renovierung nach Einzug, Auffrischung nach vielen Jahren, Umbau eines Kellers oder Home­office.'
  }
];

export default function LeistungenOverview() {
  return (
    <SeoPage
      title="Unsere Leistungen | FarbWelt Maler Express Service Dormagen"
      description="Malerarbeiten, Tapezieren, Renovierung, Wohnungsübergabe, Trockenbau und Bodenverlegung — alles aus einer Hand für Dormagen und Umgebung. Transparente Festpreise, kostenlose Besichtigung."
      canonicalPath="/leistungen"
      kicker="Leistungen"
      heroTitle="Alles, was wir für Sie machen"
      heroSubtitle="Sechs Kern-Leistungen für Privat- und Gewerbekunden in Dormagen und Umgebung. Als Komplettauftrag oder einzeln."
      jsonLd={[
        getLocalBusinessSchema(),
        getBreadcrumbSchema([
          { name: 'Startseite', item: '/' },
          { name: 'Leistungen', item: '/leistungen' }
        ]),
        {
          '@context': 'https://schema.org',
          '@type': 'ItemList',
          itemListElement: SERVICES.map((s, i) => ({
            '@type': 'ListItem',
            position: i + 1,
            item: {
              '@type': 'Service',
              name: s.title,
              url: `${BUSINESS.domain}/leistungen/${s.slug}`,
              provider: { '@type': 'Organization', name: BUSINESS.name },
              areaServed: BUSINESS.serviceAreas.slice(0, 5).map(a => a)
            }
          }))
        }
      ]}
    >
      <div className="not-prose grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {SERVICES.map(s => (
          <Link
            key={s.slug}
            to={`/leistungen/${s.slug}`}
            className="group block p-6 bg-white border border-gray-200 rounded-xl hover:border-[#9B1B30] hover:shadow-lg transition-all"
          >
            <div className="w-11 h-11 rounded-lg bg-[#9B1B30]/10 flex items-center justify-center mb-4">
              <s.icon className="w-5 h-5 text-[#9B1B30]" />
            </div>
            <h2 className="text-lg font-bold text-[#1A1A1A] mb-1 mt-0 group-hover:text-[#9B1B30] transition-colors">
              {s.title}
            </h2>
            <p className="text-gray-600 text-sm leading-relaxed mb-4">{s.short}</p>
            <span className="text-[#9B1B30] text-sm font-semibold inline-flex items-center gap-1">
              Details ansehen <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </span>
          </Link>
        ))}
      </div>

      <CtaInline text="Nicht sicher, was Sie brauchen? Wir schauen kostenlos vorbei." />

      <h2>Warum diese Leistungen aus einer Hand?</h2>
      <p>
        In den meisten Wohnungen hängt eines mit dem anderen zusammen: Neuer Anstrich braucht
        Unter­grund­vorbereitung. Neue Tapete braucht sauberen Unter­grund. Renovierung heißt oft
        auch Trocken­bau und Boden. Statt drei verschiedene Betriebe zu koordinieren — mit drei
        Terminen, drei Rechnungen und drei möglichen Fehler­quellen — bekommen Sie bei uns alles
        aus einer Hand, mit einem Ansprech­partner und einem klaren Festpreis.
      </p>

      <h2>Für wen wir arbeiten</h2>
      <ul>
        <li><strong>Privat­kunden</strong> — Miet­wohnungen, Eigen­heime, Renovierungen vor dem Einzug oder Auszug.</li>
        <li><strong>Vermieter und Haus­verwaltungen</strong> — Zwischen­renovierungen, Treppen­häuser, Objekt­gruppen.</li>
        <li><strong>Gewerbe­kunden</strong> — Büros, Praxen, Ladenlokale, kleinere Gastro­nomie.</li>
      </ul>
    </SeoPage>
  );
}
